<!--
 * @Descripttion: 登录页面组件
 * @Author: congz
 * @Date: 2020-06-11 11:08:34
 * @LastEditors: congz
 * @LastEditTime: 2020-08-19 10:14:30
--> 

<template>
  <div class="login">
    <div>
      <el-card class="box-card" shadow="hover">
        <router-link class="login-logo-link" to="/">
          <img class="login-logo" src="../assets/imgs/clogo.png" alt />
        </router-link>
        <div class="clearfix">
          <span>Login</span>
        </div>
        <div class="item">
          <el-form :model="form" status-icon :rules="rules" ref="form">
            <el-form-item prop="user_name">
              <el-input v-model="form.user_name" placeholder="Username"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input type="password" v-model="form.password" placeholder="Password"></el-input>
            </el-form-item>
          </el-form>
<!--          <div id="captcha">-->
<!--            <p id="wait">Loading verification code ...</p>-->
<!--          </div>-->
          <div style="margin-top:15px">
            <a href="javascript:;" class="btn-gradient desert block" @click="login('form')">Login</a>
          </div>
          <el-link
            type="primary"
            href="/#/register"
            style="float:right;margin-bottom:10px;"
          >Don't have an account? Please register first ></el-link>
        </div>
        <div class="line"></div>
<!--        <div class="logo">-->
<!--          <div class="logo-info">其他账号登录:</div>-->
<!--          <div class="logo-login">-->
<!--            <div @click="qqInit">-->
<!--              <img src="../assets/imgs/QQlogo.png" alt />-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
      </el-card>
    </div>
  </div>
</template>
<script src="../assets/gt.js"></script>
<script>
import { mapActions } from 'vuex'
import * as userAPI from '@/api/users'
require('../assets/gt.js')
var captcha
export default {
  name: 'Login',
  data() {
    var validateUser = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('enter one user name'))
      } else if (value.length < 5 || value.length > 15) {
        callback(new Error('The username length should be between 5 and 15'))
      }
      callback()
    }
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter the password'))
      } else if (value.length < 8 || value.length > 16) {
        callback(new Error('The password length should be between 8 and 16'))
      }
      callback()
    }
    return {
      form: {
        user_name: '',
        password: '',
        challenge: '',
        validate: '',
        seccode: ''
      },
      rules: {
        user_name: [{ validator: validateUser, trigger: 'blur' }],
        password: [{ validator: validatePass, trigger: 'blur' }]
      }
    }
  },
  methods: {
    ...mapActions(['setUser']),
    login(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) {
          return
        }
        // var result = captcha.getValidate()
        // if (!result) {
        //   this.notifyError('Please verify', null)
        //   return
        // }
        // ;(this.form.challenge = result.geetest_challenge),
        //   (this.form.validate = result.geetest_validate),
        //   (this.form.seccode = result.geetest_seccode),
          userAPI
            .postLogin(this.form)
            .then(res => {
              if (res.status === 404) {
                this.notifyError('Verification failed', res.msg)
              } else if (res.status === 200) {
                // 登录信息存到本地
                let user = JSON.stringify(res.data.user)
                localStorage.setItem('user', user)
                localStorage.setItem('token', res.data.token)
                // 登录信息存到vuex
                this.setUser(res.data.user)
                // 弹出通知框提示登录成功信息
                this.notifySucceed('Login successful')
                this.$router.push({
                  name: 'Home'
                })
              } else {
                this.notifyError('Login failed', res.msg)
              }
            })
            .catch(error => {
              this.notifyError('Login failed', error)
            })
      })
    },
    qqInit() {
      userAPI.qqInit().then(res => {
        if (res.status === 200) {
          window.location.href = res.data
        }
      })
    },
    init_geetest() {
      userAPI.geetest().then(res => {
        window.initGeetest(
          {
            gt: res.gt,
            challenge: res.challenge,
            new_captcha: res.new_captcha,
            offline: !res.success,
            product: 'popup',
            width: '100%'
          },
          function(captchaObj) {
            captcha = captchaObj
            captchaObj.appendTo('#captcha')
            captchaObj.onReady(function() {
              document.getElementById('wait').style.display = 'none'
            })
          }
        )
      })
    }
  },
  mounted() {
    this.init_geetest()
  },

  components: {}
}
</script>

<style scoped>
@import '../assets/css/button.css';
.text {
  font-size: 14px;
}

.item {
  margin: 0 auto;
  width: 300px;
}

.clearfix {
  font-size: 20px;
  margin-bottom: 20px;
}

.box-card {
  margin: 0 auto;
  text-align: center;
  width: 400px;
  margin-top: 100px;
  margin-bottom: 300px;
  border-radius: 10px;
}
.login-logo-link {
  display: flex;
  justify-content: center;
}
.login-logo {
  width: 120px;
  height: auto;
}
.box-card .line {
  height: 30px;
  width: 300px;
  margin: 0 auto;
  border-bottom: 1px solid #c0c0c0;
}
/*其他账号登录*/
.box-card .logo {
  width: 300px;
  margin: 0 auto;
  height: 30px;
  display: flex;
  align-items: center;
}
.box-card .logo .logo-info {
  font-size: 14px;
  color: #757575;
}
.box-card .logo .logo-login {
  height: 15px;
  margin-left: 10px;
}
/*其他账号登录END*/
</style>
